function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function keysToString(object) {
  let newObj = {};
  Object.keys(object).forEach((key) => (newObj[key] = String(object[key])));
  return newObj;
}

function filterAndSortEvents(events) {
  const publicEvents = events.filter(
    (event) => event.visibile?.toLowerCase() === "public"
  );
  return publicEvents
    .slice()
    .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate));
}

function fixUrl(url) {
  if (!url) return url;
  return url.replace(/([^:]\/)\/+/g, '$1');
}

export { classNames, keysToString, filterAndSortEvents, fixUrl };
